import { AppBar, Link, Toolbar } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import * as Sentry from '@sentry/browser';
import React, { Component } from 'react';
import theme from '../../theme';
import Bouton from '../Button/Bouton';
import LogoHeader from '../../ressources/images/logo_vertuloo_vert.png';

interface IProps {
  children: JSX.Element;
}

interface IState {
  hasError: boolean;
  eventId?: any;
}

class ErrorBoundary extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      hasError: false,
      eventId: null,
    };
  }

  static getDerivedStateFromError(error: any) {
    return { hasError: true };
  }

  handleClick() {
    window.location.reload();
  }

  render() {
    if (this.state.hasError) {
      return (
        <ThemeProvider theme={theme}>
          <AppBar position="static" className="containerError">
            <Toolbar className="header">
              <Link href={'/'} className="logoConteneur">
                <img src={LogoHeader} className="logo" alt="" />
              </Link>
            </Toolbar>
          </AppBar>
          <div style={{ textAlign: 'center' }}>
            <Typography align="center" variant="body2">
              Une erreur inattendue s'est produite
            </Typography>
            <Bouton
              color="primary"
              type="button"
              label={'Réessayer'}
              onClick={this.handleClick}
              className="button"
            />
          </div>
        </ThemeProvider>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
